import { Flex, FlexProps, Tag, TagLabel } from '@chakra-ui/react';
import { myAgencyCreatorCardTrackId } from '~/screens/MyAgency/components/StackView/CreatorInfo/constants';
import { ICreator } from '~/types';

import { HighlightSearchTerm } from '../HighlightSearchTerm';
import { filterCategories } from './CategoryTag.utils';

interface ICategoryTagProps extends FlexProps {
  creator: ICreator;
  isTTASearch?: boolean;
}
export const CategoryTag: React.FC<ICategoryTagProps> = ({
  creator,
  isTTASearch,
  ...props
}) => {
  const { categoryAgency } = creator;
  const filteredVerticals = filterCategories(categoryAgency);

  return (
    <Flex
      justify="wrap"
      alignItems="center"
      gap={1}
      {...props}
      track-id={myAgencyCreatorCardTrackId.verticals}
    >
      {filteredVerticals.map((vertical) => (
        <Tag
          key={vertical.name}
          size="md"
          borderRadius="xl"
          variant="outline"
          color={vertical.color}
          colorScheme={vertical.color}
          border={`1px solid ${vertical.color}`}
        >
          <TagLabel>
            <HighlightSearchTerm enableHighlighting={!isTTASearch}>
              {vertical.name}
            </HighlightSearchTerm>
          </TagLabel>
        </Tag>
      ))}
    </Flex>
  );
};
